import React, { useEffect, useRef } from "react";
import { Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {
  ContainerButton,
  Input,
  TextTitle,
  Title,
} from "../../../../../styles/global";
import Panel from "../../../../../components/Panel";
import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import { Link, useParams } from "react-router-dom";
import useInstanciaProtocolo from "../../../../../actions/cruds/Protocolo/useInstanciaProtocolo";

const InstanciaProtocoloView: React.FC = () => {
  const { instanciaId } = useParams();
  const { instanciaProtocolo, getInstanciaProtocolo } = useInstanciaProtocolo();

  const formRef = useRef<FormHandles>(null);

  useEffect(() => {
    getInstanciaProtocolo(instanciaId);
  }, []);

  return (
    <Container>
      <Title>
        <span>Visualizar Instância do Protocolo</span>
      </Title>

      <Form id="form1" ref={formRef}>
        <Panel titulo="Instância">
          <Grid container spacing={6}>
            <Grid xs={12}>
              <TextTitle>Nome:</TextTitle>
              <Input type="text" name="nome" value={instanciaProtocolo.nome} disabled />
            </Grid>
          </Grid>
        </Panel>
        <ContainerButton>
          <Link to="/protocolo/cadastros/instancia">
            <button>Voltar</button>
          </Link>
        </ContainerButton>
      </Form>
    </Container>
  );
};

export default InstanciaProtocoloView;
